
export enum Scalable {
    TRUE = "T",
    FALSE ="F"
}